(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery_cv__aeroo"] && !Shopify.designMode) return;
  try {
    /**
 * <aeroo-gallery> custom element
 * Replaces Dawn's <media-gallery> for Aeroo Pro products.
 *
 * Navigation entry points:
 *   - Click thumb (desktop) / segment (mobile) / prev/next arrow (desktop)
 *   - Swipe / mouse drag / arrow keys
 *
 * Zoom entry point (desktop only, >=1230px):
 *   - Click the active slide → opens lightbox modal with full-res image,
 *     scroll/click to zoom, drag to pan, Esc/X to close.
 *
 * Configurator entry points:
 *   - gallery.swapProduct(p)        — legacy in-place swap, kept for compatibility
 *   - gallery.rebuildFromImages(a)  — Path B rebuild, used by configurator__aeroo.js
 */
if (!customElements.get('aeroo-gallery')) {
  customElements.define(
    'aeroo-gallery',
    class AerooGallery extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.totalSlides = parseInt(this.dataset.mediaCount, 10) || 0;
      }

      connectedCallback() {
        if (this.totalSlides === 0) return;

        this.track = this.querySelector('.aeroo-gallery__track');
        this.slides = Array.from(this.querySelectorAll('.aeroo-gallery__slide'));
        this.thumbs = Array.from(this.querySelectorAll('.aeroo-gallery__thumb'));
        this.segments = Array.from(this.querySelectorAll('.aeroo-gallery__indicator-segment'));
        this.prevBtn = this.querySelector('.aeroo-gallery__nav--prev');
        this.nextBtn = this.querySelector('.aeroo-gallery__nav--next');
        this.trackWrap = this.querySelector('.aeroo-gallery__track-wrap');
        this.lightbox = this.querySelector('.aeroo-gallery-lightbox');

        this._bindEvents();
        this._setupLightbox();
        this._update();
      }

      _bindEvents() {
        var self = this;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', function (e) {
            e.preventDefault();
            self.goTo(self.currentIndex - 1);
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            self.goTo(self.currentIndex + 1);
          });
        }

        this.thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            var idx = parseInt(thumb.dataset.index, 10);
            if (!Number.isNaN(idx)) self.goTo(idx);
          });
        });

        this.segments.forEach(function (seg) {
          seg.addEventListener('click', function (e) {
            e.preventDefault();
            var idx = parseInt(seg.dataset.index, 10);
            if (!Number.isNaN(idx)) self.goTo(idx);
          });
        });

        this._setupSwipe();
        this._setupMouseDrag();
        this._setupKeyboard();
      }

      _setupSwipe() {
        if (!this.trackWrap) return;
        var self = this;
        var startX = 0;
        var startY = 0;
        var dragging = false;

        this.trackWrap.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length !== 1) return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            dragging = true;
          },
          { passive: true }
        );

        this.trackWrap.addEventListener(
          'touchend',
          function (e) {
            if (!dragging) return;
            dragging = false;
            var endX = e.changedTouches[0].clientX;
            var endY = e.changedTouches[0].clientY;
            var dx = startX - endX;
            var dy = startY - endY;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
              if (dx > 0) self.goTo(self.currentIndex + 1);
              else self.goTo(self.currentIndex - 1);
            }
          },
          { passive: true }
        );

        this.trackWrap.addEventListener('touchcancel', function () {
          dragging = false;
        });
      }

      _setupMouseDrag() {
        if (!this.trackWrap) return;
        var self = this;
        var startX = 0;
        var dragging = false;

        this.trackWrap.addEventListener('mousedown', function (e) {
          startX = e.clientX;
          dragging = true;
        });

        document.addEventListener('mouseup', function (e) {
          if (!dragging) return;
          dragging = false;
          var dx = startX - e.clientX;
          if (Math.abs(dx) > 60) {
            if (dx > 0) self.goTo(self.currentIndex + 1);
            else self.goTo(self.currentIndex - 1);
          }
        });

        this.trackWrap.addEventListener('dragstart', function (e) {
          e.preventDefault();
        });
      }

      _setupKeyboard() {
        var self = this;
        this.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            self.goTo(self.currentIndex - 1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            self.goTo(self.currentIndex + 1);
          }
        });
      }

      goTo(index) {
        if (this.totalSlides === 0) return;
        var clamped = Math.max(0, Math.min(this.totalSlides - 1, index));
        if (clamped === this.currentIndex) return;
        this.currentIndex = clamped;
        this._update();
      }

      _update() {
        if (this.track) {
          var offset = (100 / this.totalSlides) * this.currentIndex;
          this.track.style.transform = 'translateX(-' + offset + '%)';
        }

        this.slides.forEach(function (slide, i) {
          slide.classList.toggle('aeroo-gallery__slide--active', i === this.currentIndex);
        }, this);

        this.thumbs.forEach(function (thumb) {
          var idx = parseInt(thumb.dataset.index, 10);
          var isActive = idx === this.currentIndex;
          thumb.classList.toggle('aeroo-gallery__thumb--active', isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        }, this);

        this.segments.forEach(function (seg, i) {
          var isActive = i === this.currentIndex;
          seg.classList.toggle('aeroo-gallery__indicator-segment--active', isActive);
          seg.setAttribute('aria-selected', isActive ? 'true' : 'false');
        }, this);

        if (this.prevBtn) {
          var atStart = this.currentIndex === 0;
          this.prevBtn.disabled = atStart;
          this.prevBtn.setAttribute('aria-disabled', String(atStart));
        }
        if (this.nextBtn) {
          var atEnd = this.currentIndex === this.totalSlides - 1;
          this.nextBtn.disabled = atEnd;
          this.nextBtn.setAttribute('aria-disabled', String(atEnd));
        }

        var status = this.querySelector('[role="status"]');
        if (status) {
          status.textContent = 'Image ' + (this.currentIndex + 1) + ' of ' + this.totalSlides;
        }
      }

      // ====================================================================
      // Lightbox / zoom modal — desktop only (>=1230px).
      // Click the active slide to open. Scroll wheel zooms toward cursor.
      // Click image to toggle 2.5x zoom centered on click. Drag to pan when
      // zoomed. Esc or X button closes. Click backdrop closes.
      // ====================================================================
      _setupLightbox() {
        if (window.matchMedia('(max-width: 1229px)').matches) return;
        if (!this.lightbox) return;

        var self = this;
        var lb = this.lightbox;
        var stage = lb.querySelector('.aeroo-gallery-lightbox__stage');
        var img = lb.querySelector('.aeroo-gallery-lightbox__img');
        var closeBtn = lb.querySelector('.aeroo-gallery-lightbox__close');

        var zoomScale = 1;
        var minScale = 1;
        var maxScale = 4;
        var panX = 0;
        var panY = 0;

        // Click the active slide → open the lightbox with that image
        this.addEventListener('click', function (e) {
          if (window.matchMedia('(max-width: 1229px)').matches) return;
          var slide = e.target.closest('.aeroo-gallery__slide');
          if (!slide || !slide.classList.contains('aeroo-gallery__slide--active')) return;
          // Don't trigger on clicks inside any interactive children
          if (e.target.closest('button, a')) return;

          var slideImg = slide.querySelector('.aeroo-gallery__image');
          if (!slideImg) return;

          img.src = self._bestSrcFor(slideImg);
          img.alt = slideImg.alt || '';

          // Reset zoom state for fresh open
          zoomScale = 1;
          panX = 0;
          panY = 0;
          stage.classList.remove('is-zoomed');
          applyTransform();

          lb.hidden = false;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              lb.classList.add('is-open');
              closeBtn.focus();
            });
          });

          document.body.style.overflow = 'hidden';
        });

        function close() {
          lb.classList.remove('is-open');
          stage.classList.remove('is-zoomed');
          document.body.style.overflow = '';
          setTimeout(function () {
            if (!lb.classList.contains('is-open')) {
              lb.hidden = true;
              img.src = '';
            }
          }, 220);
        }

        closeBtn.addEventListener('click', close);

        // Click on the image toggles zoom; click on the stage outside closes
        stage.addEventListener('click', function (e) {
          if (e.target === img) {
            if (zoomScale > 1) {
              zoomScale = 1;
              panX = 0;
              panY = 0;
              stage.classList.remove('is-zoomed');
            } else {
              var rect = img.getBoundingClientRect();
              var cx = e.clientX - rect.left - rect.width / 2;
              var cy = e.clientY - rect.top - rect.height / 2;
              zoomScale = 2.5;
              panX = -cx * (zoomScale - 1);
              panY = -cy * (zoomScale - 1);
              stage.classList.add('is-zoomed');
            }
            applyTransform();
            return;
          }
          // Backdrop click — close
          close();
        });

        // Esc key
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
        });

        // Wheel zoom toward cursor
        stage.addEventListener('wheel', function (e) {
          if (!lb.classList.contains('is-open')) return;
          e.preventDefault();
          var rect = img.getBoundingClientRect();
          var cx = e.clientX - rect.left - rect.width / 2;
          var cy = e.clientY - rect.top - rect.height / 2;

          var delta = -e.deltaY * 0.003;
          var prevScale = zoomScale;
          zoomScale = Math.min(maxScale, Math.max(minScale, zoomScale + delta));

          if (zoomScale !== prevScale) {
            var ratio = zoomScale / prevScale;
            panX = (panX - cx) * ratio + cx;
            panY = (panY - cy) * ratio + cy;
          }

          if (zoomScale > 1) {
            stage.classList.add('is-zoomed');
          } else {
            panX = 0;
            panY = 0;
            stage.classList.remove('is-zoomed');
          }
          applyTransform();
        }, { passive: false });

        // Drag-to-pan when zoomed
        var dragging = false;
        var dragStartX = 0;
        var dragStartY = 0;
        var dragOriginX = 0;
        var dragOriginY = 0;

        img.addEventListener('mousedown', function (e) {
          if (zoomScale <= 1) return;
          dragging = true;
          dragStartX = e.clientX;
          dragStartY = e.clientY;
          dragOriginX = panX;
          dragOriginY = panY;
          stage.style.cursor = 'grabbing';
          e.preventDefault();
        });

        document.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          panX = dragOriginX + (e.clientX - dragStartX);
          panY = dragOriginY + (e.clientY - dragStartY);
          applyTransform();
        });

        document.addEventListener('mouseup', function () {
          if (!dragging) return;
          dragging = false;
          stage.style.cursor = '';
        });

        function applyTransform() {
          img.style.transform =
            'translate(-50%, -50%) translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomScale + ')';
        }
      }

      // Pick the highest-quality source available for the lightbox by parsing
      // the srcset and taking the largest width entry. Falls back to src.
      _bestSrcFor(imgEl) {
        if (imgEl.srcset) {
          var entries = imgEl.srcset.split(',').map(function (s) {
            var parts = s.trim().split(/\s+/);
            return { url: parts[0], w: parseInt(parts[1] || '0', 10) };
          });
          entries.sort(function (a, b) { return b.w - a.w; });
          if (entries.length && entries[0].url) {
            var u = entries[0].url;
            return u.indexOf('//') === 0 ? window.location.protocol + u : u;
          }
        }
        return imgEl.currentSrc || imgEl.src;
      }

      // ====================================================================
      // Legacy in-place swap. Not used by configurator__aeroo.js (Path B);
      // kept for any caller that prefers swapping without rebuilding DOM.
      // ====================================================================
      async swapProduct(p) {
        var firstSlide = this.slides[0];
        var firstSlideImg = firstSlide ? firstSlide.querySelector('.aeroo-gallery__image') : null;
        if (firstSlideImg && p.featured_image && firstSlideImg.src !== p.featured_image) {
          var tmp = new Image();
          tmp.src = p.featured_image;
          try { await tmp.decode(); } catch (e) { /* ignore */ }
          firstSlideImg.src = p.featured_image;
          firstSlideImg.srcset = '';
        }

        if (this.track) {
          var prevTransition = this.track.style.transition;
          this.track.style.transition = 'none';
          this.currentIndex = 0;
          this._update();
          void this.track.offsetWidth;
          this.track.style.transition = prevTransition;
        }

        var self = this;
        var swapRest = function () {
          if (p.images && p.images.length) {
            p.images.forEach(function (src, i) {
              if (i === 0) return;
              var slide = self.slides[i];
              if (!slide) return;
              var img = slide.querySelector('.aeroo-gallery__image');
              if (img) {
                img.src = src;
                img.srcset = '';
              }
            });
            self.thumbs.forEach(function (thumb, i) {
              var img = thumb.querySelector('.aeroo-gallery__thumb-image');
              if (img && p.images[i]) {
                img.src = p.images[i];
                img.srcset = '';
              }
            });
          }
        };

        if (document.startViewTransition) {
          document.startViewTransition(swapRest);
        } else {
          swapRest();
        }
      }

      // ====================================================================
      // Rebuild the gallery for a new product with any image count.
      // Slides and indicator update immediately. Thumbnail strip fades out,
      // then fades back in with the new thumbs — visible-but-gentle cue
      // that the gallery has changed.
      // ====================================================================
      rebuildFromImages(images) {
        if (!images || !images.length) return;
        var self = this;

        this.classList.add('is-swapping');

        setTimeout(function () {
          self._doRebuild(images);
          requestAnimationFrame(function () {
            self.classList.remove('is-swapping');
          });
        }, 220);
      }

      _doRebuild(images) {
        var visibleThumbLimit = parseInt(this.dataset.visibleThumbs, 10) || 7;
        var hiddenThumbCount = Math.max(0, images.length - visibleThumbLimit);
        var newCount = images.length;
        var self = this;

        // ---- 1. Rebuild slide track ----
        if (!this.track) this.track = this.querySelector('.aeroo-gallery__track');
        if (!this.track) return;

        this.track.style.width = (newCount * 100) + '%';
        var slidePct = (100 / newCount).toFixed(4);

        var slidesHTML = images.map(function (img, i) {
          var fallback = typeof img === 'string' ? img : (img.src || img.src1400);
          var srcset = '';
          if (typeof img === 'object' && img.src750) {
            srcset = img.src750  + ' 750w, '
                  + img.src1100 + ' 1100w, '
                  + img.src1400 + ' 1400w, '
                  + img.src1920 + ' 1920w, '
                  + img.src2400 + ' 2400w, '
                  + img.src3000 + ' 3000w';
          }

          return ''
            + '<li class="aeroo-gallery__slide' + (i === 0 ? ' aeroo-gallery__slide--active' : '') + '"'
            +   ' data-index="' + i + '"'
            +   ' style="width:' + slidePct + '%;">'
            + '<div class="aeroo-gallery__media">'
            + '<img src="' + fallback + '"'
            + (srcset ? ' srcset="' + srcset + '"' : '')
            +   ' sizes="(min-width: 1230px) 50vw, 100vw"'
            +   ' class="aeroo-gallery__image"'
            +   ' loading="' + (i === 0 ? 'eager' : 'lazy') + '"'
            +   ' alt="">'
            + '</div>'
            + '</li>';
        }).join('');
        this.track.innerHTML = slidesHTML;

        // ---- 2. Rebuild thumbnail strip ----
        var thumbsWrap = this.querySelector('.aeroo-gallery__thumbs');
        if (thumbsWrap) {
          var thumbsHTML = images.slice(0, visibleThumbLimit).map(function (img, i) {
            var fallback = typeof img === 'string' ? img : (img.src || img.src1400);
            var srcSmall = typeof img === 'object' && img.src750 ? img.src750 : fallback;
            var srcsetThumb = '';
            if (typeof img === 'object' && img.src750) {
              srcsetThumb = img.src750 + ' 2x';
            }
            var isOverlay = (i === visibleThumbLimit - 1) && hiddenThumbCount > 0;

            return ''
              + '<button type="button"'
              +   ' class="aeroo-gallery__thumb' + (i === 0 ? ' aeroo-gallery__thumb--active' : '')
              +     (isOverlay ? ' aeroo-gallery__thumb--more' : '') + '"'
              +   ' data-index="' + i + '"'
              +   ' role="tab"'
              +   ' aria-selected="' + (i === 0 ? 'true' : 'false') + '">'
              + '<img src="' + srcSmall + '"'
              + (srcsetThumb ? ' srcset="' + srcsetThumb + '"' : '')
              +   ' class="aeroo-gallery__thumb-image" loading="lazy" alt="">'
              + (isOverlay ? '<span class="aeroo-gallery__thumb-overlay" aria-hidden="true">+' + hiddenThumbCount + '</span>' : '')
              + '</button>';
          }).join('');
          thumbsWrap.innerHTML = thumbsHTML;
        }

        // ---- 3. Rebuild mobile indicator segments ----
        var indicatorWrap = this.querySelector('.aeroo-gallery__indicator');
        if (indicatorWrap) {
          var segmentsHTML = images.map(function (_, i) {
            return ''
              + '<button type="button"'
              +   ' class="aeroo-gallery__indicator-segment' + (i === 0 ? ' aeroo-gallery__indicator-segment--active' : '') + '"'
              +   ' data-index="' + i + '"'
              +   ' role="tab"'
              +   ' aria-selected="' + (i === 0 ? 'true' : 'false') + '"'
              +   ' tabindex="-1"></button>';
          }).join('');
          indicatorWrap.innerHTML = segmentsHTML;
        }

        // ---- 4. Update nav button state ----
        if (this.prevBtn) {
          this.prevBtn.disabled = true;
          this.prevBtn.setAttribute('aria-disabled', 'true');
        }
        if (this.nextBtn) {
          var atEnd = newCount <= 1;
          this.nextBtn.disabled = atEnd;
          this.nextBtn.setAttribute('aria-disabled', String(atEnd));
        }

        // ---- 5. Refresh state and re-bind events on new nodes ----
        this.totalSlides = newCount;
        this.currentIndex = 0;
        this.dataset.mediaCount = String(newCount);

        this.slides = Array.from(this.querySelectorAll('.aeroo-gallery__slide'));
        this.thumbs = Array.from(this.querySelectorAll('.aeroo-gallery__thumb'));
        this.segments = Array.from(this.querySelectorAll('.aeroo-gallery__indicator-segment'));

        this.thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            var idx = parseInt(thumb.dataset.index, 10);
            if (!Number.isNaN(idx)) self.goTo(idx);
          });
        });
        this.segments.forEach(function (seg) {
          seg.addEventListener('click', function (e) {
            e.preventDefault();
            var idx = parseInt(seg.dataset.index, 10);
            if (!Number.isNaN(idx)) self.goTo(idx);
          });
        });

        // Reset transform
        if (this.track) {
          var prevTransition = this.track.style.transition;
          this.track.style.transition = 'none';
          this.track.style.transform = 'translateX(0%)';
          void this.track.offsetWidth;
          this.track.style.transition = prevTransition;
        }

        var status = this.querySelector('[role="status"]');
        if (status) status.textContent = 'Image 1 of ' + newCount;
      }
    }
  );
}
//   /**
//  * <aeroo-gallery> custom element
//  * Replaces Dawn's <media-gallery> for Aeroo Pro products.
//  *
//  * Navigation entry points:
//  *   - Click thumb (desktop) / segment (mobile) / prev/next arrow (desktop)
//  *   - Swipe / mouse drag / arrow keys
//  *
//  * Configurator entry points:
//  *   - gallery.swapProduct(p)        — legacy in-place swap, kept for compatibility
//  *   - gallery.rebuildFromImages(a)  — Path B rebuild, used by configurator__aeroo.js
//  */
// if (!customElements.get('aeroo-gallery')) {
//   customElements.define(
//     'aeroo-gallery',
//     class AerooGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.currentIndex = 0;
//         this.totalSlides = parseInt(this.dataset.mediaCount, 10) || 0;
//       }

//       connectedCallback() {
//         if (this.totalSlides === 0) return;

//         this.track = this.querySelector('.aeroo-gallery__track');
//         this.slides = Array.from(this.querySelectorAll('.aeroo-gallery__slide'));
//         this.thumbs = Array.from(this.querySelectorAll('.aeroo-gallery__thumb'));
//         this.segments = Array.from(this.querySelectorAll('.aeroo-gallery__indicator-segment'));
//         this.prevBtn = this.querySelector('.aeroo-gallery__nav--prev');
//         this.nextBtn = this.querySelector('.aeroo-gallery__nav--next');
//         this.trackWrap = this.querySelector('.aeroo-gallery__track-wrap');

//         this._bindEvents();
//         this._update();
//       }

//       _bindEvents() {
//         var self = this;

//         if (this.prevBtn) {
//           this.prevBtn.addEventListener('click', function (e) {
//             e.preventDefault();
//             self.goTo(self.currentIndex - 1);
//           });
//         }
//         if (this.nextBtn) {
//           this.nextBtn.addEventListener('click', function (e) {
//             e.preventDefault();
//             self.goTo(self.currentIndex + 1);
//           });
//         }

//         this.thumbs.forEach(function (thumb) {
//           thumb.addEventListener('click', function (e) {
//             e.preventDefault();
//             var idx = parseInt(thumb.dataset.index, 10);
//             if (!Number.isNaN(idx)) self.goTo(idx);
//           });
//         });

//         this.segments.forEach(function (seg) {
//           seg.addEventListener('click', function (e) {
//             e.preventDefault();
//             var idx = parseInt(seg.dataset.index, 10);
//             if (!Number.isNaN(idx)) self.goTo(idx);
//           });
//         });

//         this._setupSwipe();
//         this._setupMouseDrag();
//         this._setupKeyboard();
//       }

//       _setupSwipe() {
//         if (!this.trackWrap) return;
//         var self = this;
//         var startX = 0;
//         var startY = 0;
//         var dragging = false;

//         this.trackWrap.addEventListener(
//           'touchstart',
//           function (e) {
//             if (e.touches.length !== 1) return;
//             startX = e.touches[0].clientX;
//             startY = e.touches[0].clientY;
//             dragging = true;
//           },
//           { passive: true }
//         );

//         this.trackWrap.addEventListener(
//           'touchend',
//           function (e) {
//             if (!dragging) return;
//             dragging = false;
//             var endX = e.changedTouches[0].clientX;
//             var endY = e.changedTouches[0].clientY;
//             var dx = startX - endX;
//             var dy = startY - endY;
//             if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
//               if (dx > 0) self.goTo(self.currentIndex + 1);
//               else self.goTo(self.currentIndex - 1);
//             }
//           },
//           { passive: true }
//         );

//         this.trackWrap.addEventListener('touchcancel', function () {
//           dragging = false;
//         });
//       }

//       _setupMouseDrag() {
//         if (!this.trackWrap) return;
//         var self = this;
//         var startX = 0;
//         var dragging = false;

//         this.trackWrap.addEventListener('mousedown', function (e) {
//           startX = e.clientX;
//           dragging = true;
//         });

//         document.addEventListener('mouseup', function (e) {
//           if (!dragging) return;
//           dragging = false;
//           var dx = startX - e.clientX;
//           if (Math.abs(dx) > 60) {
//             if (dx > 0) self.goTo(self.currentIndex + 1);
//             else self.goTo(self.currentIndex - 1);
//           }
//         });

//         this.trackWrap.addEventListener('dragstart', function (e) {
//           e.preventDefault();
//         });
//       }

//       _setupKeyboard() {
//         var self = this;
//         this.addEventListener('keydown', function (e) {
//           if (e.key === 'ArrowLeft') {
//             e.preventDefault();
//             self.goTo(self.currentIndex - 1);
//           } else if (e.key === 'ArrowRight') {
//             e.preventDefault();
//             self.goTo(self.currentIndex + 1);
//           }
//         });
//       }

//       goTo(index) {
//         if (this.totalSlides === 0) return;
//         var clamped = Math.max(0, Math.min(this.totalSlides - 1, index));
//         if (clamped === this.currentIndex) return;
//         this.currentIndex = clamped;
//         this._update();
//       }

//       _update() {
//         if (this.track) {
//           var offset = (100 / this.totalSlides) * this.currentIndex;
//           this.track.style.transform = 'translateX(-' + offset + '%)';
//         }

//         this.slides.forEach(function (slide, i) {
//           slide.classList.toggle('aeroo-gallery__slide--active', i === this.currentIndex);
//         }, this);

//         this.thumbs.forEach(function (thumb) {
//           var idx = parseInt(thumb.dataset.index, 10);
//           var isActive = idx === this.currentIndex;
//           thumb.classList.toggle('aeroo-gallery__thumb--active', isActive);
//           thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
//         }, this);

//         this.segments.forEach(function (seg, i) {
//           var isActive = i === this.currentIndex;
//           seg.classList.toggle('aeroo-gallery__indicator-segment--active', isActive);
//           seg.setAttribute('aria-selected', isActive ? 'true' : 'false');
//         }, this);

//         if (this.prevBtn) {
//           var atStart = this.currentIndex === 0;
//           this.prevBtn.disabled = atStart;
//           this.prevBtn.setAttribute('aria-disabled', String(atStart));
//         }
//         if (this.nextBtn) {
//           var atEnd = this.currentIndex === this.totalSlides - 1;
//           this.nextBtn.disabled = atEnd;
//           this.nextBtn.setAttribute('aria-disabled', String(atEnd));
//         }

//         var status = this.querySelector('[role="status"]');
//         if (status) {
//           status.textContent = 'Image ' + (this.currentIndex + 1) + ' of ' + this.totalSlides;
//         }
//       }

//       // ====================================================================
//       // Legacy in-place swap. Not used by configurator__aeroo.js (Path B);
//       // kept for any caller that prefers swapping without rebuilding DOM.
//       // ====================================================================
//       async swapProduct(p) {
//         var firstSlide = this.slides[0];
//         var firstSlideImg = firstSlide ? firstSlide.querySelector('.aeroo-gallery__image') : null;
//         if (firstSlideImg && p.featured_image && firstSlideImg.src !== p.featured_image) {
//           var tmp = new Image();
//           tmp.src = p.featured_image;
//           try { await tmp.decode(); } catch (e) { /* ignore */ }
//           firstSlideImg.src = p.featured_image;
//           firstSlideImg.srcset = '';
//         }

//         if (this.track) {
//           var prevTransition = this.track.style.transition;
//           this.track.style.transition = 'none';
//           this.currentIndex = 0;
//           this._update();
//           void this.track.offsetWidth;
//           this.track.style.transition = prevTransition;
//         }

//         var self = this;
//         var swapRest = function () {
//           if (p.images && p.images.length) {
//             p.images.forEach(function (src, i) {
//               if (i === 0) return;
//               var slide = self.slides[i];
//               if (!slide) return;
//               var img = slide.querySelector('.aeroo-gallery__image');
//               if (img) {
//                 img.src = src;
//                 img.srcset = '';
//               }
//             });
//             self.thumbs.forEach(function (thumb, i) {
//               var img = thumb.querySelector('.aeroo-gallery__thumb-image');
//               if (img && p.images[i]) {
//                 img.src = p.images[i];
//                 img.srcset = '';
//               }
//             });
//           }
//         };

//         if (document.startViewTransition) {
//           document.startViewTransition(swapRest);
//         } else {
//           swapRest();
//         }
//       }

//       // ====================================================================
//       // Rebuild the gallery for a new product with any image count.
//       // Slides and indicator update immediately. Thumbnail strip fades out,
//       // then fades back in with the new thumbs — visible-but-gentle cue
//       // that the gallery has changed.
//       // ====================================================================
//       rebuildFromImages(images) {
//         if (!images || !images.length) return;
//         var self = this;

//         // Add the fade-out class. CSS animates thumbs opacity to 0 over 220ms.
//         this.classList.add('is-swapping');

//         // After the fade-out completes, rebuild the DOM, then on the next
//         // animation frame remove the class so the new thumbs fade back in.
//         setTimeout(function () {
//           self._doRebuild(images);
//           requestAnimationFrame(function () {
//             self.classList.remove('is-swapping');
//           });
//         }, 220);
//       }

//       _doRebuild(images) {
//         var visibleThumbLimit = parseInt(this.dataset.visibleThumbs, 10) || 6;
//         var hiddenThumbCount = Math.max(0, images.length - visibleThumbLimit);
//         var newCount = images.length;
//         var self = this;

//         // ---- 1. Rebuild slide track ----
//         if (!this.track) this.track = this.querySelector('.aeroo-gallery__track');
//         if (!this.track) return;

//         this.track.style.width = (newCount * 100) + '%';
//         var slidePct = (100 / newCount).toFixed(4);

//         var slidesHTML = images.map(function (img, i) {
//           // Accept either string URLs (legacy) or {src, src750, src1100, ...} objects (Path B).
//           var fallback = typeof img === 'string' ? img : (img.src || img.src1400);
//           var srcset = '';
//           if (typeof img === 'object' && img.src750) {
//             srcset = img.src750  + ' 750w, '
//                   + img.src1100 + ' 1100w, '
//                   + img.src1400 + ' 1400w, '
//                   + img.src1920 + ' 1920w, '
//                   + img.src2400 + ' 2400w, '
//                   + img.src3000 + ' 3000w';
//           }

//           return ''
//             + '<li class="aeroo-gallery__slide' + (i === 0 ? ' aeroo-gallery__slide--active' : '') + '"'
//             +   ' data-index="' + i + '"'
//             +   ' style="width:' + slidePct + '%;">'
//             + '<div class="aeroo-gallery__media">'
//             + '<img src="' + fallback + '"'
//             + (srcset ? ' srcset="' + srcset + '"' : '')
//             +   ' sizes="(min-width: 1230px) 50vw, 100vw"'
//             +   ' class="aeroo-gallery__image"'
//             +   ' loading="' + (i === 0 ? 'eager' : 'lazy') + '"'
//             +   ' alt="">'
//             + '</div>'
//             + '</li>';
//         }).join('');
//         this.track.innerHTML = slidesHTML;

//         // ---- 2. Rebuild thumbnail strip ----
//         var thumbsWrap = this.querySelector('.aeroo-gallery__thumbs');
//         if (thumbsWrap) {
//           var thumbsHTML = images.slice(0, visibleThumbLimit).map(function (img, i) {
//             var fallback = typeof img === 'string' ? img : (img.src || img.src1400);
//             // Thumbs render at 100px CSS. 2x for retina = 200px; src750 covers it well.
//             var srcSmall = typeof img === 'object' && img.src750 ? img.src750 : fallback;
//             var srcsetThumb = '';
//             if (typeof img === 'object' && img.src750) {
//               srcsetThumb = img.src750 + ' 2x';
//             }
//             var isOverlay = (i === visibleThumbLimit - 1) && hiddenThumbCount > 0;

//             return ''
//               + '<button type="button"'
//               +   ' class="aeroo-gallery__thumb' + (i === 0 ? ' aeroo-gallery__thumb--active' : '')
//               +     (isOverlay ? ' aeroo-gallery__thumb--more' : '') + '"'
//               +   ' data-index="' + i + '"'
//               +   ' role="tab"'
//               +   ' aria-selected="' + (i === 0 ? 'true' : 'false') + '">'
//               + '<img src="' + srcSmall + '"'
//               + (srcsetThumb ? ' srcset="' + srcsetThumb + '"' : '')
//               +   ' class="aeroo-gallery__thumb-image" loading="lazy" alt="">'
//               + (isOverlay ? '<span class="aeroo-gallery__thumb-overlay" aria-hidden="true">+' + hiddenThumbCount + '</span>' : '')
//               + '</button>';
//           }).join('');
//           thumbsWrap.innerHTML = thumbsHTML;
//         }

//         // ---- 3. Rebuild mobile indicator segments ----
//         var indicatorWrap = this.querySelector('.aeroo-gallery__indicator');
//         if (indicatorWrap) {
//           var segmentsHTML = images.map(function (_, i) {
//             return ''
//               + '<button type="button"'
//               +   ' class="aeroo-gallery__indicator-segment' + (i === 0 ? ' aeroo-gallery__indicator-segment--active' : '') + '"'
//               +   ' data-index="' + i + '"'
//               +   ' role="tab"'
//               +   ' aria-selected="' + (i === 0 ? 'true' : 'false') + '"'
//               +   ' tabindex="-1"></button>';
//           }).join('');
//           indicatorWrap.innerHTML = segmentsHTML;
//         }

//         // ---- 4. Update nav button state ----
//         if (this.prevBtn) {
//           this.prevBtn.disabled = true;
//           this.prevBtn.setAttribute('aria-disabled', 'true');
//         }
//         if (this.nextBtn) {
//           var atEnd = newCount <= 1;
//           this.nextBtn.disabled = atEnd;
//           this.nextBtn.setAttribute('aria-disabled', String(atEnd));
//         }

//         // ---- 5. Refresh state and re-bind events on new nodes ----
//         this.totalSlides = newCount;
//         this.currentIndex = 0;
//         this.dataset.mediaCount = String(newCount);

//         this.slides = Array.from(this.querySelectorAll('.aeroo-gallery__slide'));
//         this.thumbs = Array.from(this.querySelectorAll('.aeroo-gallery__thumb'));
//         this.segments = Array.from(this.querySelectorAll('.aeroo-gallery__indicator-segment'));

//         this.thumbs.forEach(function (thumb) {
//           thumb.addEventListener('click', function (e) {
//             e.preventDefault();
//             var idx = parseInt(thumb.dataset.index, 10);
//             if (!Number.isNaN(idx)) self.goTo(idx);
//           });
//         });
//         this.segments.forEach(function (seg) {
//           seg.addEventListener('click', function (e) {
//             e.preventDefault();
//             var idx = parseInt(seg.dataset.index, 10);
//             if (!Number.isNaN(idx)) self.goTo(idx);
//           });
//         });

//         // Reset transform
//         if (this.track) {
//           var prevTransition = this.track.style.transition;
//           this.track.style.transition = 'none';
//           this.track.style.transform = 'translateX(0%)';
//           void this.track.offsetWidth;
//           this.track.style.transition = prevTransition;
//         }

//         var status = this.querySelector('[role="status"]');
//         if (status) status.textContent = 'Image 1 of ' + newCount;
//       }
//     }
//   );
// }
  } catch(e) { console.error(e); }
})();

})();
